import React, { memo, useEffect, useState } from 'react';
import Dialog from '../../components/Dialog/Dialog';
import styles from './Message.module.less';
import { setMessageVisible } from '../../actions/layout';
import { useDispatch, useSelector } from 'react-redux';
import { setMessageActiveTab } from '../../actions/layout';
import { createSelector } from 'reselect';
import Comment from '../../pages/Message/Comment/Comment';
import Collect from '../../pages/Message/Collect/Collect';
import { getMessageList, resetMessageList, deleteMessageHot } from '../../actions/message';
import Login from '../../static/message_login.svg';
import Default from '../../static/message_default.svg';
import Btn from '../../components/Btn/Btn';
import Loading from '../../components/Loading/Loading';
import { logging, logPostInfo } from '../../actions/log';

const selectMessageLayout = createSelector(
  state => state.layout,
  layout => ({
    activeTab: layout.messageActiveTab,
  }),
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectMessage = createSelector(
  state => state.message,
  message => ({
    commentList: message.commentList,
    collectList: message.collectList,
    hot: message.hot,
    commentLoading: message.commentLoading,
    collectLoading: message.collectLoading,
  }),
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(() => {
  const dispatch = useDispatch();
  const { activeTab } = useSelector(selectMessageLayout);
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const [loginStatus, setLoginStatus] = useState(false);
  const { commentList = [], collectList = [], hot, commentLoading, collectLoading } = useSelector(
    selectMessage,
  );

  const [initTime, setInitTime] = useState(+new Date());
  const logPV = () => {
    dispatch(
      logging({
        category: 'P',
        action: `Message`,
        label: '',
        param2: {
          source: 'Message',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Message',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };

  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Message`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  };
  useEffect(() => {
    setInitTime(Date.now());
    logPV();
    return () => {
      leaveTimeLog();
    };
  }, []);

  useEffect(() => {
    const newloginStatus = window.CallNativeMethod('get_login_status');
    if (!(newloginStatus !== '1' || !userInfo.st)) {
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [userInfo]);

  const handleClose = () => {
    dispatch(setMessageVisible(false));
    dispatch(resetMessageList());
  };

  useEffect(() => {
    if (!loginStatus) {
      dispatch(resetMessageList());
      return;
    }
    if (activeTab === 'comment' && commentList.length === 0) {
      dispatch(deleteMessageHot({ code: 1 }));
      dispatch(getMessageList({ code: 1, refresh: true, skip: 0, limit: 24 }));
    } else if (collectList.length === 0) {
      dispatch(deleteMessageHot({ code: 2 }));
      dispatch(getMessageList({ code: 2, refresh: true, skip: 0, limit: 24 }));
    }
  }, [activeTab, loginStatus]);

  const handleClickTab = tab => () => {
    dispatch(setMessageActiveTab(tab));
    dispatch(
      logging({
        category: 'C',
        action: 'Message_Tab',
        label: '',
        param2: {
          source: 'Message',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: tab === 'comment' ? 'comment' : 'zan',
        },
      }),
    );
  };

  const handelLogin = () => {
    // eslint-disable-next-line no-unused-expressions
    window && window.CallNativeMethod && window.CallNativeMethod('login');
  };
  return (
    <Dialog
      title={'消息中心'}
      maskStyle={styles.mask}
      containerStyle={styles.mask_container}
      handleClose={handleClose}
    >
      <div className={styles.content_container}>
        <div className={styles.header}>
          <div
            className={`${activeTab === 'comment' ? styles.active : ''} ${styles.item}`}
            onClick={handleClickTab('comment')}
          >
            评论与回复
            {hot && hot[1] === '1' && <div className={styles.hot} />}
          </div>
          <div
            className={`${activeTab === 'collect' ? styles.active : ''} ${styles.item}`}
            onClick={handleClickTab('collect')}
          >
            收藏与点赞
            {hot && hot[2] === '1' && <div className={styles.hot} />}
          </div>
        </div>
        <div className={styles.content}>
          {!loginStatus && (
            <div className={styles.login}>
              <img src={Login} />
              <div className={styles.login_text}>登录后，查看我的消息</div>
              <Btn className={styles.login_btn} primary handleClick={handelLogin}>
                登录
              </Btn>
            </div>
          )}
          {loginStatus && (
            <>
              {((activeTab === 'comment' &&
                !commentLoading &&
                commentList &&
                commentList.length === 0) ||
                (activeTab === 'collect' &&
                  !collectLoading &&
                  collectList &&
                  collectList.length === 0)) && (
                <div className={styles.nodata}>
                  <img src={Default} />
                  <div className={styles.default_text}>啊哦，当前您尚未收到任何消息</div>
                </div>
              )}
              {((activeTab === 'comment' &&
                commentLoading &&
                commentList &&
                commentList.length === 0) ||
                (activeTab === 'collect' &&
                  collectLoading &&
                  collectList &&
                  collectList.length === 0)) && (
                <div className={styles.loading}>
                  <Loading />
                </div>
              )}
            </>
          )}

          {loginStatus && (
            <>
              {activeTab === 'comment' && <Comment />}
              {activeTab === 'collect' && <Collect />}
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
});
